'use client';

import React from 'react';
import { ChevronDown } from '@drift-labs/icons';
import IconButton, {
	IconButtonProps,
} from 'src/components/primitives/IconButton/IconButton';
import { cj } from 'src/utils/classNames';

type Props = Omit<Partial<IconButtonProps>, 'children' | 'icon'> & {
	direction: 'up' | 'down' | 'left' | 'right';
};

export default function ChevronButton({
	direction,
	onClick,
	className,
	size = 'sm',
	...rest
}: Props) {
	const rotateClassName = {
		up: '[&_svg]:rotate-180',
		right: '[&_svg]:-rotate-90',
		down: '[&_svg]:rotate-0',
		left: '[&_svg]:rotate-90',
	}[direction];

	return (
		<IconButton
			size={size}
			className={cj(
				'ease-in-out-quint [&_svg]:transition-transform',
				rotateClassName,
				className
			)}
			onClick={onClick}
			icon={ChevronDown}
			{...rest}
		/>
	);
}
